import { ShortDate } from "@/components/l10n/DateFormat.tsx";
import C from "@/components/sidebar/StandardSidebar.module.css";
import { InfoTooltip } from "@/components/WTooltip.tsx";
import type { MetalCommitmentWithEndsAt } from "@/modules/metal/commitment/commitment.ts";
import { cn } from "@/utils/classNames.ts";
import { Trans } from "@lingui/react/macro";
import { DAYS } from "@warrenio/utils/timeUnits";
import { type ReactNode, useState } from "react";

const t_Committed = <Trans comment="Server has been pre-paid">Committed</Trans>;

function CommitmentTooltip({ commitment }: { commitment: MetalCommitmentWithEndsAt }) {
    const endDate = new Date(commitment.ends_at);

    // Grab the time once when the component mounts
    const [now] = useState(() => Date.now());

    const daysRemaining = Math.floor((endDate.getTime() - now) / DAYS);

    const tooltip = (
        <Trans>
            Reserved and prepaid until <ShortDate date={endDate} /> ({daysRemaining} days remaining). Price shown as a
            monthly equivalent.
        </Trans>
    );

    return (
        <div className="text-muted font-size-small flex items-center justify-end">
            {t_Committed}
            <InfoTooltip className="ml-1" text={tooltip} />
        </div>
    );
}

export function CommitmentPriceBlock({
    commitment,
    children,
}: {
    commitment: MetalCommitmentWithEndsAt;
    children?: ReactNode;
}) {
    return (
        <div className={cn(C.StandardBlockInfo, "flex gap-2")}>
            {children}
            <CommitmentTooltip commitment={commitment} />
        </div>
    );
}
